module.exports = __webpack_public_path__ + "static/media/instructor.c363fea4.png";